import { ImgHTMLAttributes } from 'react';

import { StripeCardDetails } from 'apis/billing';
import { getCreditCardAttributes } from 'utils/billing';

type CreditCardImageProps = {
  creditCard?: StripeCardDetails['cc_type'];
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'loading'>;

export const CreditCardImage = ({
  creditCard: creditCardType,
  ...rest
}: CreditCardImageProps): JSX.Element => {
  return (
    <img
      src={getCreditCardAttributes(creditCardType)?.imageSrc}
      alt={creditCardType}
      loading="lazy"
      {...rest}
    />
  );
};
